import { defineComponent as _defineComponent } from 'vue'
import {
  MembershipTermsModal,
  ConfirmResponse
} from '@/modules/onboarding/fast-register/components/MembershipTermsModal';
import {
  goToNextRoute,
  goToPreviousRoute
} from '@/modules/common/store/RegulatoryUpdateRoutesOrchestrator';
import { acceptTerms } from '@/modules/account/views/RegulatoryUpdate/services';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegulatoryUpdateAcceptTerms',
  setup(__props) {

function back() {
  goToPreviousRoute();
}

async function confirmTerms(response: ConfirmResponse) {
  if (response.acceptedTerms) {
    await fetchAcceptTerms();
  }
}

async function fetchAcceptTerms() {
  try {
    await acceptTerms();

    goToNextRoute();
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Houve um problema ao aceitar os termos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  }
}

return { __sfc: true,back, confirmTerms, fetchAcceptTerms, MembershipTermsModal }
}

})